import { create } from "zustand";

/**
 * Global second-resolution clock.
 *
 * A single setInterval drives all countdown displays — components never
 * manage their own timers. Subscribe with useClockStore((s) => s.now).
 */
export const useClockStore = create((set) => {
  setInterval(() => set({ now: Date.now() }), 1000);
  return { now: Date.now() };
});
